import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/parts/demands/importer`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/parts/demand/demand-importer')({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/parts/demands/importer', search: true, replace: true });
    },
});
